/* eslint-disable */
import * as APITypes from '../types';
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};
/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const appleDomainVerificationFile = /* GraphQL */ `
  query AppleDomainVerificationFile {
    appleDomainVerificationFile
  }
` as GeneratedQuery<
  Record<string, never>,
  APITypes.AppleDomainVerificationFileQuery
>;
export const authorization = /* GraphQL */ `
  query Authorization($authorization_id: String!) {
    authorization(authorization_id: $authorization_id) {
      account_code
      additional_purchase_data {
        level3_data_line_item {
          item_code
          item_description
          item_qty_exp
          prod_code
          qty
          tax_amount
          tax_ind
          tax_rate
          tax_rt_exp
          tax_type_id
          unit_cost
          unit_of_msure
        }
        level3_data_summary {
          dest_postal_code
          discnt_amt
          duty_amt
          frght_amt
          order_num
          prod_desc
          purch_idfr
          tax_amt
          tax_ind
        }
      }
      amount
      authorization_date
      authorization_id
      avs_status
      captured_amount
      currency
      device_id
      expiration_date
      failure_reasons
      fee_mode
      fees
      invoice {
        account_code
        created_date
        currency
        due_by
        fee_mode
        invoice_amount
        invoice_date
        invoice_description
        invoice_id
        invoice_name
        merchant_invoice_number
        merchant_uid
        metadata
        offline_transactions {
          amount
          instance_id
          invoice_id
          note
          transaction_date
          type
        }
        payor {
          address_line1
          address_line2
          city
          country
          created_row_at
          email
          full_name
          merchant_uid
          metadata
          payor_id
          phone
          postal_code
          region
          updated_row_at
        }
        reference
        settings {
          accepted_payment_methods {
            ach
            card
            cash
          }
          is_secure
          require_payor_address
          security_pin
        }
        status
        total_paid_amount
        updated_row_at
      }
      merchant_uid
      metadata
      payment_method {
        address_line1
        address_line2
        bank_account_type
        bank_code
        barcode_id
        card_brand
        card_type
        city
        country
        created_row_at
        cvv_status
        exp_date
        full_name
        is_active
        issuing_country_code
        last_four
        merchant_uid
        metadata
        payment_method_id
        payment_type
        payor {
          address_line1
          address_line2
          city
          country
          created_row_at
          email
          full_name
          merchant_uid
          metadata
          payor_id
          phone
          postal_code
          region
          updated_row_at
        }
        postal_code
        region
        updated_row_at
        wallet_type
      }
      processor
      reference
      sale_id
      status
      timezone
      transaction_id
      updated_row_at
    }
  }
` as GeneratedQuery<
  APITypes.AuthorizationQueryVariables,
  APITypes.AuthorizationQuery
>;
export const authorizations = /* GraphQL */ `
  query Authorizations(
    $query: SqlQuery
    $limit: Int
    $offset: String
    $direction: MoveDirection
    $offset_id: String
  ) {
    authorizations(
      query: $query
      limit: $limit
      offset: $offset
      direction: $direction
      offset_id: $offset_id
    ) {
      items {
        account_code
        additional_purchase_data {
          level3_data_line_item {
            item_code
            item_description
            item_qty_exp
            prod_code
            qty
            tax_amount
            tax_ind
            tax_rate
            tax_rt_exp
            tax_type_id
            unit_cost
            unit_of_msure
          }
          level3_data_summary {
            dest_postal_code
            discnt_amt
            duty_amt
            frght_amt
            order_num
            prod_desc
            purch_idfr
            tax_amt
            tax_ind
          }
        }
        amount
        authorization_date
        authorization_id
        avs_status
        captured_amount
        currency
        device_id
        expiration_date
        failure_reasons
        fee_mode
        fees
        invoice {
          account_code
          created_date
          currency
          due_by
          fee_mode
          invoice_amount
          invoice_date
          invoice_description
          invoice_id
          invoice_name
          merchant_invoice_number
          merchant_uid
          metadata
          offline_transactions {
            amount
            instance_id
            invoice_id
            note
            transaction_date
            type
          }
          payor {
            address_line1
            address_line2
            city
            country
            created_row_at
            email
            full_name
            merchant_uid
            metadata
            payor_id
            phone
            postal_code
            region
            updated_row_at
          }
          reference
          settings {
            accepted_payment_methods {
              ach
              card
              cash
            }
            is_secure
            require_payor_address
            security_pin
          }
          status
          total_paid_amount
          updated_row_at
        }
        merchant_uid
        metadata
        payment_method {
          address_line1
          address_line2
          bank_account_type
          bank_code
          barcode_id
          card_brand
          card_type
          city
          country
          created_row_at
          cvv_status
          exp_date
          full_name
          is_active
          issuing_country_code
          last_four
          merchant_uid
          metadata
          payment_method_id
          payment_type
          payor {
            address_line1
            address_line2
            city
            country
            created_row_at
            email
            full_name
            merchant_uid
            metadata
            payor_id
            phone
            postal_code
            region
            updated_row_at
          }
          postal_code
          region
          updated_row_at
          wallet_type
        }
        processor
        reference
        sale_id
        status
        timezone
        transaction_id
        updated_row_at
      }
      total_row_count
    }
  }
` as GeneratedQuery<
  APITypes.AuthorizationsQueryVariables,
  APITypes.AuthorizationsQuery
>;
export const availableFundsBalance = /* GraphQL */ `
  query AvailableFundsBalance($merchant_uid: ID!) {
    availableFundsBalance(merchant_uid: $merchant_uid) {
      instructional_hold_balance
      reserve_balance
      instruction_window_status
      instructional_hold_balance_updated
    }
  }
` as GeneratedQuery<
  APITypes.AvailableFundsBalanceQueryVariables,
  APITypes.AvailableFundsBalanceQuery
>;
export const backOfficeKey = /* GraphQL */ `
  query BackOfficeKey(
    $merchant_uid: String!
    $entity_level: BackofficeKeyEntityLevel!
  ) {
    backOfficeKey(merchant_uid: $merchant_uid, entity_level: $entity_level) {
      created_date
      enabled
      entity_level
      key_name
      last_accessed_date
      merchant_uid
    }
  }
` as GeneratedQuery<
  APITypes.BackOfficeKeyQueryVariables,
  APITypes.BackOfficeKeyQuery
>;
export const barcode = /* GraphQL */ `
  query Barcode($merchant_uid: ID!, $barcode_id: String!) {
    barcode(merchant_uid: $merchant_uid, barcode_id: $barcode_id) {
      account_code
      amount
      barcode_id
      barcode_url
      email_or_phone
      expiration_date
      fees
      full_name
      invoice_id
      merchant_uid
      metadata
      payor {
        address_line1
        address_line2
        city
        country
        created_row_at
        email
        full_name
        merchant_uid
        metadata
        payor_id
        phone
        postal_code
        region
        updated_row_at
      }
      payor_id
      reference
      sale_id
    }
  }
` as GeneratedQuery<APITypes.BarcodeQueryVariables, APITypes.BarcodeQuery>;
export const dashboardAuthRate = /* GraphQL */ `
  query DashboardAuthRate(
    $merchant_uid: String!
    $start_date: AWSDate!
    $end_date: AWSDate!
  ) {
    dashboardAuthRate(
      merchant_uid: $merchant_uid
      start_date: $start_date
      end_date: $end_date
    ) {
      card
      ach
    }
  }
` as GeneratedQuery<
  APITypes.DashboardAuthRateQueryVariables,
  APITypes.DashboardAuthRateQuery
>;
export const dashboardDisputeRate = /* GraphQL */ `
  query DashboardDisputeRate(
    $merchant_uid: String!
    $start_date: AWSDate!
    $end_date: AWSDate!
  ) {
    dashboardDisputeRate(
      merchant_uid: $merchant_uid
      start_date: $start_date
      end_date: $end_date
    ) {
      card
      ach
    }
  }
` as GeneratedQuery<
  APITypes.DashboardDisputeRateQueryVariables,
  APITypes.DashboardDisputeRateQuery
>;
export const dashboardFundingTotals = /* GraphQL */ `
  query DashboardFundingTotals(
    $merchant_uid: String!
    $start_date: AWSDate!
    $end_date: AWSDate!
  ) {
    dashboardFundingTotals(
      merchant_uid: $merchant_uid
      start_date: $start_date
      end_date: $end_date
    ) {
      payments
      refunds
      fees
      ach_returns
      disputes
      adjustments
      settlement_count
      deposit
      splits
    }
  }
` as GeneratedQuery<
  APITypes.DashboardFundingTotalsQueryVariables,
  APITypes.DashboardFundingTotalsQuery
>;
export const dashboardPaymentMethod = /* GraphQL */ `
  query DashboardPaymentMethod(
    $merchant_uid: String!
    $start_date: AWSDate!
    $end_date: AWSDate!
  ) {
    dashboardPaymentMethod(
      merchant_uid: $merchant_uid
      start_date: $start_date
      end_date: $end_date
    ) {
      card {
        amount
        count
      }
      ach {
        amount
        count
      }
      cash {
        amount
        count
      }
    }
  }
` as GeneratedQuery<
  APITypes.DashboardPaymentMethodQueryVariables,
  APITypes.DashboardPaymentMethodQuery
>;
export const dashboardPayments = /* GraphQL */ `
  query DashboardPayments(
    $merchant_uid: String!
    $start_date: AWSDate!
    $end_date: AWSDate!
  ) {
    dashboardPayments(
      merchant_uid: $merchant_uid
      start_date: $start_date
      end_date: $end_date
    ) {
      gross_amount
    }
  }
` as GeneratedQuery<
  APITypes.DashboardPaymentsQueryVariables,
  APITypes.DashboardPaymentsQuery
>;
export const dashboardTimeSeries = /* GraphQL */ `
  query DashboardTimeSeries(
    $merchant_uid: String!
    $start_date: AWSDate!
    $end_date: AWSDate!
  ) {
    dashboardTimeSeries(
      merchant_uid: $merchant_uid
      start_date: $start_date
      end_date: $end_date
    ) {
      data_points {
        date
        amount
      }
    }
  }
` as GeneratedQuery<
  APITypes.DashboardTimeSeriesQueryVariables,
  APITypes.DashboardTimeSeriesQuery
>;
export const dashboardTransactionCounts = /* GraphQL */ `
  query DashboardTransactionCounts(
    $merchant_uid: String!
    $start_date: AWSDate!
    $end_date: AWSDate!
  ) {
    dashboardTransactionCounts(
      merchant_uid: $merchant_uid
      start_date: $start_date
      end_date: $end_date
    ) {
      current_count
      previous_count
    }
  }
` as GeneratedQuery<
  APITypes.DashboardTransactionCountsQueryVariables,
  APITypes.DashboardTransactionCountsQuery
>;
export const devices = /* GraphQL */ `
  query Devices(
    $query: SqlQuery
    $limit: Int
    $offset: String
    $direction: MoveDirection
    $offset_id: String
  ) {
    devices(
      query: $query
      limit: $limit
      offset: $offset
      direction: $direction
      offset_id: $offset_id
    ) {
      items {
        device_id
        device_description
        device_name
        device_properties
        is_active
        merchant_uid
        processor
        processor_device_id
      }
      total_row_count
    }
  }
` as GeneratedQuery<APITypes.DevicesQueryVariables, APITypes.DevicesQuery>;
export const dispute = /* GraphQL */ `
  query Dispute($dispute_id: String!) {
    dispute(dispute_id: $dispute_id) {
      amount
      category
      currency
      dispute_date
      dispute_id
      evidence_last_send_date
      expiration_date
      merchant_uid
      metadata
      processor
      processor_data
      processor_dispute_id
      status
      reason
      reason_message
      settlement_batch
      settlement_deposit_batch
      settlement_withdrawal_batch
      transaction {
        account_code
        ach_return_details {
          return_code
          return_details
          transfer_type
        }
        additional_purchase_data {
          level3_data_line_item {
            item_code
            item_description
            item_qty_exp
            prod_code
            qty
            tax_amount
            tax_ind
            tax_rate
            tax_rt_exp
            tax_type_id
            unit_cost
            unit_of_msure
          }
          level3_data_summary {
            dest_postal_code
            discnt_amt
            duty_amt
            frght_amt
            order_num
            prod_desc
            purch_idfr
            tax_amt
            tax_ind
          }
        }
        authorization_id
        avs_status
        currency
        device_id
        dispute_status
        failure_reasons
        fee_mode
        fees
        flag_for_review
        gross_amount
        invoice {
          account_code
          created_date
          currency
          due_by
          fee_mode
          invoice_amount
          invoice_date
          invoice_description
          invoice_id
          invoice_name
          merchant_invoice_number
          merchant_uid
          metadata
          offline_transactions {
            amount
            instance_id
            invoice_id
            note
            transaction_date
            type
          }
          payor {
            address_line1
            address_line2
            city
            country
            created_row_at
            email
            full_name
            merchant_uid
            metadata
            payor_id
            phone
            postal_code
            region
            updated_row_at
          }
          reference
          settings {
            accepted_payment_methods {
              ach
              card
              cash
            }
            is_secure
            require_payor_address
            security_pin
          }
          status
          total_paid_amount
          updated_row_at
        }
        is_settled
        merchant {
          ach_active
          card_active
          cash_active
          country_code
          is_system
          merchant_name
          merchant_uid
          metadata
          parent_merchant_uid
          submitted_onboarding
          updated_row_at
        }
        merchant_uid
        metadata
        net_amount
        parent_id
        payment_method {
          address_line1
          address_line2
          bank_account_type
          bank_code
          barcode_id
          card_brand
          card_type
          city
          country
          created_row_at
          cvv_status
          exp_date
          full_name
          is_active
          issuing_country_code
          last_four
          merchant_uid
          metadata
          payment_method_id
          payment_type
          payor {
            address_line1
            address_line2
            city
            country
            created_row_at
            email
            full_name
            merchant_uid
            metadata
            payor_id
            phone
            postal_code
            region
            updated_row_at
          }
          postal_code
          region
          updated_row_at
          wallet_type
        }
        processor
        recurring {
          account_code
          amount_per_payment
          created_date
          currency
          fee_mode
          fee_per_payment
          is_active
          is_processing
          recurring_id
          merchant_uid
          metadata
          mute_all_emails
          next_payment_date
          payment_interval
          payment_method {
            address_line1
            address_line2
            bank_account_type
            bank_code
            barcode_id
            card_brand
            card_type
            city
            country
            created_row_at
            cvv_status
            exp_date
            full_name
            is_active
            issuing_country_code
            last_four
            merchant_uid
            metadata
            payment_method_id
            payment_type
            payor {
              address_line1
              address_line2
              city
              country
              created_row_at
              email
              full_name
              merchant_uid
              metadata
              payor_id
              phone
              postal_code
              region
              updated_row_at
            }
            postal_code
            region
            updated_row_at
            wallet_type
          }
          payor {
            address_line1
            address_line2
            city
            country
            created_row_at
            email
            full_name
            merchant_uid
            metadata
            payor_id
            phone
            postal_code
            region
            updated_row_at
          }
          prev_payment_date
          recurring_description
          recurring_name
          reference
          remaining_payments
          status
          total_amount_per_payment
          updated_row_at
        }
        reference
        refund_reason {
          reason_code
          reason_details
        }
        refund_voidable
        refunded_amount
        sale_id
        settlement_batch
        splits {
          account_code
          amount
          currency
          created_at
          id
          merchant {
            ach_active
            card_active
            cash_active
            country_code
            is_system
            merchant_name
            merchant_uid
            metadata
            parent_merchant_uid
            submitted_onboarding
            updated_row_at
          }
          metadata
          payment_method {
            address_line1
            address_line2
            bank_account_type
            bank_code
            barcode_id
            card_brand
            card_type
            city
            country
            created_row_at
            cvv_status
            exp_date
            full_name
            is_active
            issuing_country_code
            last_four
            merchant_uid
            metadata
            payment_method_id
            payment_type
            payor {
              address_line1
              address_line2
              city
              country
              created_row_at
              email
              full_name
              merchant_uid
              metadata
              payor_id
              phone
              postal_code
              region
              updated_row_at
            }
            postal_code
            region
            updated_row_at
            wallet_type
          }
          reference
          settlement_batch
          transaction_id
          updated_row_at
        }
        status
        timezone
        transaction_date
        transaction_id
        transaction_type
        updated_row_at
      }
      updated_date
      updated_row_at
    }
  }
` as GeneratedQuery<APITypes.DisputeQueryVariables, APITypes.DisputeQuery>;
export const disputeEvidence = /* GraphQL */ `
  query DisputeEvidence($dispute_id: String!, $evidence_id: String!) {
    disputeEvidence(dispute_id: $dispute_id, evidence_id: $evidence_id) {
      dispute {
        amount
        category
        currency
        dispute_date
        dispute_id
        evidence_last_send_date
        expiration_date
        merchant_uid
        metadata
        processor
        processor_data
        processor_dispute_id
        status
        reason
        reason_message
        settlement_batch
        settlement_deposit_batch
        settlement_withdrawal_batch
        transaction {
          account_code
          ach_return_details {
            return_code
            return_details
            transfer_type
          }
          additional_purchase_data {
            level3_data_line_item {
              item_code
              item_description
              item_qty_exp
              prod_code
              qty
              tax_amount
              tax_ind
              tax_rate
              tax_rt_exp
              tax_type_id
              unit_cost
              unit_of_msure
            }
            level3_data_summary {
              dest_postal_code
              discnt_amt
              duty_amt
              frght_amt
              order_num
              prod_desc
              purch_idfr
              tax_amt
              tax_ind
            }
          }
          authorization_id
          avs_status
          currency
          device_id
          dispute_status
          failure_reasons
          fee_mode
          fees
          flag_for_review
          gross_amount
          invoice {
            account_code
            created_date
            currency
            due_by
            fee_mode
            invoice_amount
            invoice_date
            invoice_description
            invoice_id
            invoice_name
            merchant_invoice_number
            merchant_uid
            metadata
            offline_transactions {
              amount
              instance_id
              invoice_id
              note
              transaction_date
              type
            }
            payor {
              address_line1
              address_line2
              city
              country
              created_row_at
              email
              full_name
              merchant_uid
              metadata
              payor_id
              phone
              postal_code
              region
              updated_row_at
            }
            reference
            settings {
              is_secure
              require_payor_address
              security_pin
            }
            status
            total_paid_amount
            updated_row_at
          }
          is_settled
          merchant {
            ach_active
            card_active
            cash_active
            country_code
            is_system
            merchant_name
            merchant_uid
            metadata
            parent_merchant_uid
            submitted_onboarding
            updated_row_at
          }
          merchant_uid
          metadata
          net_amount
          parent_id
          payment_method {
            address_line1
            address_line2
            bank_account_type
            bank_code
            barcode_id
            card_brand
            card_type
            city
            country
            created_row_at
            cvv_status
            exp_date
            full_name
            is_active
            issuing_country_code
            last_four
            merchant_uid
            metadata
            payment_method_id
            payment_type
            payor {
              address_line1
              address_line2
              city
              country
              created_row_at
              email
              full_name
              merchant_uid
              metadata
              payor_id
              phone
              postal_code
              region
              updated_row_at
            }
            postal_code
            region
            updated_row_at
            wallet_type
          }
          processor
          recurring {
            account_code
            amount_per_payment
            created_date
            currency
            fee_mode
            fee_per_payment
            is_active
            is_processing
            recurring_id
            merchant_uid
            metadata
            mute_all_emails
            next_payment_date
            payment_interval
            payment_method {
              address_line1
              address_line2
              bank_account_type
              bank_code
              barcode_id
              card_brand
              card_type
              city
              country
              created_row_at
              cvv_status
              exp_date
              full_name
              is_active
              issuing_country_code
              last_four
              merchant_uid
              metadata
              payment_method_id
              payment_type
              postal_code
              region
              updated_row_at
              wallet_type
            }
            payor {
              address_line1
              address_line2
              city
              country
              created_row_at
              email
              full_name
              merchant_uid
              metadata
              payor_id
              phone
              postal_code
              region
              updated_row_at
            }
            prev_payment_date
            recurring_description
            recurring_name
            reference
            remaining_payments
            status
            total_amount_per_payment
            updated_row_at
          }
          reference
          refund_reason {
            reason_code
            reason_details
          }
          refund_voidable
          refunded_amount
          sale_id
          settlement_batch
          splits {
            account_code
            amount
            currency
            created_at
            id
            merchant {
              ach_active
              card_active
              cash_active
              country_code
              is_system
              merchant_name
              merchant_uid
              metadata
              parent_merchant_uid
              submitted_onboarding
              updated_row_at
            }
            metadata
            payment_method {
              address_line1
              address_line2
              bank_account_type
              bank_code
              barcode_id
              card_brand
              card_type
              city
              country
              created_row_at
              cvv_status
              exp_date
              full_name
              is_active
              issuing_country_code
              last_four
              merchant_uid
              metadata
              payment_method_id
              payment_type
              postal_code
              region
              updated_row_at
              wallet_type
            }
            reference
            settlement_batch
            transaction_id
            updated_row_at
          }
          status
          timezone
          transaction_date
          transaction_id
          transaction_type
          updated_row_at
        }
        updated_date
        updated_row_at
      }
      evidence_id
      dispute_id
      evidence_date
      filename
      mime_type
      merchant_uid
      metadata
      processor
      processor_data
      processor_evidence_id
      status
      updated_date
      updated_row_at
    }
  }
` as GeneratedQuery<
  APITypes.DisputeEvidenceQueryVariables,
  APITypes.DisputeEvidenceQuery
>;
export const disputes = /* GraphQL */ `
  query Disputes(
    $query: SqlQuery
    $limit: Int
    $offset: String
    $direction: MoveDirection
    $offset_id: String
  ) {
    disputes(
      query: $query
      limit: $limit
      offset: $offset
      direction: $direction
      offset_id: $offset_id
    ) {
      items {
        amount
        category
        currency
        dispute_date
        dispute_id
        evidence_last_send_date
        expiration_date
        merchant_uid
        metadata
        processor
        processor_data
        processor_dispute_id
        status
        reason
        reason_message
        settlement_batch
        settlement_deposit_batch
        settlement_withdrawal_batch
        transaction {
          account_code
          ach_return_details {
            return_code
            return_details
            transfer_type
          }
          additional_purchase_data {
            level3_data_line_item {
              item_code
              item_description
              item_qty_exp
              prod_code
              qty
              tax_amount
              tax_ind
              tax_rate
              tax_rt_exp
              tax_type_id
              unit_cost
              unit_of_msure
            }
            level3_data_summary {
              dest_postal_code
              discnt_amt
              duty_amt
              frght_amt
              order_num
              prod_desc
              purch_idfr
              tax_amt
              tax_ind
            }
          }
          authorization_id
          avs_status
          currency
          device_id
          dispute_status
          failure_reasons
          fee_mode
          fees
          flag_for_review
          gross_amount
          invoice {
            account_code
            created_date
            currency
            due_by
            fee_mode
            invoice_amount
            invoice_date
            invoice_description
            invoice_id
            invoice_name
            merchant_invoice_number
            merchant_uid
            metadata
            offline_transactions {
              amount
              instance_id
              invoice_id
              note
              transaction_date
              type
            }
            payor {
              address_line1
              address_line2
              city
              country
              created_row_at
              email
              full_name
              merchant_uid
              metadata
              payor_id
              phone
              postal_code
              region
              updated_row_at
            }
            reference
            settings {
              is_secure
              require_payor_address
              security_pin
            }
            status
            total_paid_amount
            updated_row_at
          }
          is_settled
          merchant {
            ach_active
            card_active
            cash_active
            country_code
            is_system
            merchant_name
            merchant_uid
            metadata
            parent_merchant_uid
            submitted_onboarding
            updated_row_at
          }
          merchant_uid
          metadata
          net_amount
          parent_id
          payment_method {
            address_line1
            address_line2
            bank_account_type
            bank_code
            barcode_id
            card_brand
            card_type
            city
            country
            created_row_at
            cvv_status
            exp_date
            full_name
            is_active
            issuing_country_code
            last_four
            merchant_uid
            metadata
            payment_method_id
            payment_type
            payor {
              address_line1
              address_line2
              city
              country
              created_row_at
              email
              full_name
              merchant_uid
              metadata
              payor_id
              phone
              postal_code
              region
              updated_row_at
            }
            postal_code
            region
            updated_row_at
            wallet_type
          }
          processor
          recurring {
            account_code
            amount_per_payment
            created_date
            currency
            fee_mode
            fee_per_payment
            is_active
            is_processing
            recurring_id
            merchant_uid
            metadata
            mute_all_emails
            next_payment_date
            payment_interval
            payment_method {
              address_line1
              address_line2
              bank_account_type
              bank_code
              barcode_id
              card_brand
              card_type
              city
              country
              created_row_at
              cvv_status
              exp_date
              full_name
              is_active
              issuing_country_code
              last_four
              merchant_uid
              metadata
              payment_method_id
              payment_type
              postal_code
              region
              updated_row_at
              wallet_type
            }
            payor {
              address_line1
              address_line2
              city
              country
              created_row_at
              email
              full_name
              merchant_uid
              metadata
              payor_id
              phone
              postal_code
              region
              updated_row_at
            }
            prev_payment_date
            recurring_description
            recurring_name
            reference
            remaining_payments
            status
            total_amount_per_payment
            updated_row_at
          }
          reference
          refund_reason {
            reason_code
            reason_details
          }
          refund_voidable
          refunded_amount
          sale_id
          settlement_batch
          splits {
            account_code
            amount
            currency
            created_at
            id
            merchant {
              ach_active
              card_active
              cash_active
              country_code
              is_system
              merchant_name
              merchant_uid
              metadata
              parent_merchant_uid
              submitted_onboarding
              updated_row_at
            }
            metadata
            payment_method {
              address_line1
              address_line2
              bank_account_type
              bank_code
              barcode_id
              card_brand
              card_type
              city
              country
              created_row_at
              cvv_status
              exp_date
              full_name
              is_active
              issuing_country_code
              last_four
              merchant_uid
              metadata
              payment_method_id
              payment_type
              postal_code
              region
              updated_row_at
              wallet_type
            }
            reference
            settlement_batch
            transaction_id
            updated_row_at
          }
          status
          timezone
          transaction_date
          transaction_id
          transaction_type
          updated_row_at
        }
        updated_date
        updated_row_at
      }
      total_row_count
    }
  }
` as GeneratedQuery<APITypes.DisputesQueryVariables, APITypes.DisputesQuery>;
export const documentVersion = /* GraphQL */ `
  query DocumentVersion($input: GetDocumentVersionInput!) {
    documentVersion(input: $input) {
      document {
        document_id
        document_version_id
        owner_type
        owner_id
        document_type
        related_entity_type
        related_entity_id
        status
        original_filename
        content_type_declared
        content_type_observed
        size_bytes_declared
        size_bytes_observed
        guardduty_scan_status
        guardduty_scan_result_status
        guardduty_status_reasons
        validation_status
        validation_mode
        validation_profile_id
        validation_profile_version
        created_at
        upload_expires_at
        uploaded_at
        guardduty_scanned_at
        validation_requested_at
        validation_completed_at
        available_at
        deleted_at
      }
      download_url
      download_method
      required_headers
      download_expires_at
    }
  }
` as GeneratedQuery<
  APITypes.DocumentVersionQueryVariables,
  APITypes.DocumentVersionQuery
>;
export const documentVersions = /* GraphQL */ `
  query DocumentVersions($input: ListDocumentVersionsInput!) {
    documentVersions(input: $input) {
      documents {
        document {
          document_id
          document_version_id
          owner_type
          owner_id
          document_type
          related_entity_type
          related_entity_id
          status
          original_filename
          content_type_declared
          content_type_observed
          size_bytes_declared
          size_bytes_observed
          guardduty_scan_status
          guardduty_scan_result_status
          guardduty_status_reasons
          validation_status
          validation_mode
          validation_profile_id
          validation_profile_version
          created_at
          upload_expires_at
          uploaded_at
          guardduty_scanned_at
          validation_requested_at
          validation_completed_at
          available_at
          deleted_at
        }
        download_url
        download_method
        required_headers
        download_expires_at
      }
    }
  }
` as GeneratedQuery<
  APITypes.DocumentVersionsQueryVariables,
  APITypes.DocumentVersionsQuery
>;
export const documentVersionsByRelatedEntity = /* GraphQL */ `
  query DocumentVersionsByRelatedEntity(
    $input: ListDocumentVersionsByRelatedEntityInput!
  ) {
    documentVersionsByRelatedEntity(input: $input) {
      documents {
        document {
          document_id
          document_version_id
          owner_type
          owner_id
          document_type
          related_entity_type
          related_entity_id
          status
          original_filename
          content_type_declared
          content_type_observed
          size_bytes_declared
          size_bytes_observed
          guardduty_scan_status
          guardduty_scan_result_status
          guardduty_status_reasons
          validation_status
          validation_mode
          validation_profile_id
          validation_profile_version
          created_at
          upload_expires_at
          uploaded_at
          guardduty_scanned_at
          validation_requested_at
          validation_completed_at
          available_at
          deleted_at
        }
        download_url
        download_method
        required_headers
        download_expires_at
      }
    }
  }
` as GeneratedQuery<
  APITypes.DocumentVersionsByRelatedEntityQueryVariables,
  APITypes.DocumentVersionsByRelatedEntityQuery
>;
export const errorText = /* GraphQL */ `
  query ErrorText($language_code: String!, $error_codes: [String]!) {
    errorText(language_code: $language_code, error_codes: $error_codes)
  }
` as GeneratedQuery<APITypes.ErrorTextQueryVariables, APITypes.ErrorTextQuery>;
export const fundingTransfers = /* GraphQL */ `
  query FundingTransfers($merchant_uid: ID!, $settlement_batch: Int!) {
    fundingTransfers(
      merchant_uid: $merchant_uid
      settlement_batch: $settlement_batch
    ) {
      transfers {
        id
        merchant_uid
        amount
        origin
        destination
        status
        reason
        transfer_date
        funds_received_date
        payment_method_id
        parent_id
        settlement_batch
        reserve_account_type
        ach_return
        reserve_reason_object
        created_at
        updated_at
      }
    }
  }
` as GeneratedQuery<
  APITypes.FundingTransfersQueryVariables,
  APITypes.FundingTransfersQuery
>;
export const generateCSV = /* GraphQL */ `
  query GenerateCSV($csvInput: CSVInput!) {
    generateCSV(csvInput: $csvInput) {
      bucket_name
      filepaths
    }
  }
` as GeneratedQuery<
  APITypes.GenerateCSVQueryVariables,
  APITypes.GenerateCSVQuery
>;
export const hostedCheckoutPage = /* GraphQL */ `
  query HostedCheckoutPage($session_id: String!) {
    hostedCheckoutPage(session_id: $session_id) {
      accepted_payment_methods
      account_code
      amount
      api_key
      call_to_action
      checkout_type
      country_code
      currency
      fee_mode
      invoice_id
      is_active
      merchant_name
      merchant_uid
      metadata
      origin
      payment_description
      payment_name
      payor {
        address_line1
        address_line2
        city
        country
        created_row_at
        email
        full_name
        merchant_uid
        metadata
        payor_id
        phone
        postal_code
        region
        updated_row_at
      }
      recurring_id
      require_phone
      wallet_checkout_details {
        paze {
          active
          paze_key
          key_scope
          merchantDetails {
            mcc
            url
            statementDescriptor
            merchantName
          }
        }
        apple {
          active
        }
        google {
          active
          merchantIdentifier
        }
      }
    }
  }
` as GeneratedQuery<
  APITypes.HostedCheckoutPageQueryVariables,
  APITypes.HostedCheckoutPageQuery
>;
export const idempotencyLookup = /* GraphQL */ `
  query IdempotencyLookup(
    $merchant_uid: String!
    $operation: IdempotencyOperation!
    $idempotency_key: String!
  ) {
    idempotencyLookup(
      merchant_uid: $merchant_uid
      operation: $operation
      idempotency_key: $idempotency_key
    ) {
      merchant_uid
      operation
      idempotency_status
      transaction_id
      transaction {
        account_code
        ach_return_details {
          return_code
          return_details
          transfer_type
        }
        additional_purchase_data {
          level3_data_line_item {
            item_code
            item_description
            item_qty_exp
            prod_code
            qty
            tax_amount
            tax_ind
            tax_rate
            tax_rt_exp
            tax_type_id
            unit_cost
            unit_of_msure
          }
          level3_data_summary {
            dest_postal_code
            discnt_amt
            duty_amt
            frght_amt
            order_num
            prod_desc
            purch_idfr
            tax_amt
            tax_ind
          }
        }
        authorization_id
        avs_status
        currency
        device_id
        dispute_status
        failure_reasons
        fee_mode
        fees
        flag_for_review
        gross_amount
        invoice {
          account_code
          created_date
          currency
          due_by
          fee_mode
          invoice_amount
          invoice_date
          invoice_description
          invoice_id
          invoice_name
          merchant_invoice_number
          merchant_uid
          metadata
          offline_transactions {
            amount
            instance_id
            invoice_id
            note
            transaction_date
            type
          }
          payor {
            address_line1
            address_line2
            city
            country
            created_row_at
            email
            full_name
            merchant_uid
            metadata
            payor_id
            phone
            postal_code
            region
            updated_row_at
          }
          reference
          settings {
            accepted_payment_methods {
              ach
              card
              cash
            }
            is_secure
            require_payor_address
            security_pin
          }
          status
          total_paid_amount
          updated_row_at
        }
        is_settled
        merchant {
          ach_active
          card_active
          cash_active
          country_code
          is_system
          merchant_name
          merchant_uid
          metadata
          parent_merchant_uid
          submitted_onboarding
          updated_row_at
        }
        merchant_uid
        metadata
        net_amount
        parent_id
        payment_method {
          address_line1
          address_line2
          bank_account_type
          bank_code
          barcode_id
          card_brand
          card_type
          city
          country
          created_row_at
          cvv_status
          exp_date
          full_name
          is_active
          issuing_country_code
          last_four
          merchant_uid
          metadata
          payment_method_id
          payment_type
          payor {
            address_line1
            address_line2
            city
            country
            created_row_at
            email
            full_name
            merchant_uid
            metadata
            payor_id
            phone
            postal_code
            region
            updated_row_at
          }
          postal_code
          region
          updated_row_at
          wallet_type
        }
        processor
        recurring {
          account_code
          amount_per_payment
          created_date
          currency
          fee_mode
          fee_per_payment
          is_active
          is_processing
          recurring_id
          merchant_uid
          metadata
          mute_all_emails
          next_payment_date
          payment_interval
          payment_method {
            address_line1
            address_line2
            bank_account_type
            bank_code
            barcode_id
            card_brand
            card_type
            city
            country
            created_row_at
            cvv_status
            exp_date
            full_name
            is_active
            issuing_country_code
            last_four
            merchant_uid
            metadata
            payment_method_id
            payment_type
            payor {
              address_line1
              address_line2
              city
              country
              created_row_at
              email
              full_name
              merchant_uid
              metadata
              payor_id
              phone
              postal_code
              region
              updated_row_at
            }
            postal_code
            region
            updated_row_at
            wallet_type
          }
          payor {
            address_line1
            address_line2
            city
            country
            created_row_at
            email
            full_name
            merchant_uid
            metadata
            payor_id
            phone
            postal_code
            region
            updated_row_at
          }
          prev_payment_date
          recurring_description
          recurring_name
          reference
          remaining_payments
          status
          total_amount_per_payment
          updated_row_at
        }
        reference
        refund_reason {
          reason_code
          reason_details
        }
        refund_voidable
        refunded_amount
        sale_id
        settlement_batch
        splits {
          account_code
          amount
          currency
          created_at
          id
          merchant {
            ach_active
            card_active
            cash_active
            country_code
            is_system
            merchant_name
            merchant_uid
            metadata
            parent_merchant_uid
            submitted_onboarding
            updated_row_at
          }
          metadata
          payment_method {
            address_line1
            address_line2
            bank_account_type
            bank_code
            barcode_id
            card_brand
            card_type
            city
            country
            created_row_at
            cvv_status
            exp_date
            full_name
            is_active
            issuing_country_code
            last_four
            merchant_uid
            metadata
            payment_method_id
            payment_type
            payor {
              address_line1
              address_line2
              city
              country
              created_row_at
              email
              full_name
              merchant_uid
              metadata
              payor_id
              phone
              postal_code
              region
              updated_row_at
            }
            postal_code
            region
            updated_row_at
            wallet_type
          }
          reference
          settlement_batch
          transaction_id
          updated_row_at
        }
        status
        timezone
        transaction_date
        transaction_id
        transaction_type
        updated_row_at
      }
      authorization_id
      authorization {
        account_code
        additional_purchase_data {
          level3_data_line_item {
            item_code
            item_description
            item_qty_exp
            prod_code
            qty
            tax_amount
            tax_ind
            tax_rate
            tax_rt_exp
            tax_type_id
            unit_cost
            unit_of_msure
          }
          level3_data_summary {
            dest_postal_code
            discnt_amt
            duty_amt
            frght_amt
            order_num
            prod_desc
            purch_idfr
            tax_amt
            tax_ind
          }
        }
        amount
        authorization_date
        authorization_id
        avs_status
        captured_amount
        currency
        device_id
        expiration_date
        failure_reasons
        fee_mode
        fees
        invoice {
          account_code
          created_date
          currency
          due_by
          fee_mode
          invoice_amount
          invoice_date
          invoice_description
          invoice_id
          invoice_name
          merchant_invoice_number
          merchant_uid
          metadata
          offline_transactions {
            amount
            instance_id
            invoice_id
            note
            transaction_date
            type
          }
          payor {
            address_line1
            address_line2
            city
            country
            created_row_at
            email
            full_name
            merchant_uid
            metadata
            payor_id
            phone
            postal_code
            region
            updated_row_at
          }
          reference
          settings {
            accepted_payment_methods {
              ach
              card
              cash
            }
            is_secure
            require_payor_address
            security_pin
          }
          status
          total_paid_amount
          updated_row_at
        }
        merchant_uid
        metadata
        payment_method {
          address_line1
          address_line2
          bank_account_type
          bank_code
          barcode_id
          card_brand
          card_type
          city
          country
          created_row_at
          cvv_status
          exp_date
          full_name
          is_active
          issuing_country_code
          last_four
          merchant_uid
          metadata
          payment_method_id
          payment_type
          payor {
            address_line1
            address_line2
            city
            country
            created_row_at
            email
            full_name
            merchant_uid
            metadata
            payor_id
            phone
            postal_code
            region
            updated_row_at
          }
          postal_code
          region
          updated_row_at
          wallet_type
        }
        processor
        reference
        sale_id
        status
        timezone
        transaction_id
        updated_row_at
      }
      locked_until
      expires_at
    }
  }
` as GeneratedQuery<
  APITypes.IdempotencyLookupQueryVariables,
  APITypes.IdempotencyLookupQuery
>;
export const instruction = /* GraphQL */ `
  query Instruction($merchant_uid: ID!, $date: AWSDate!) {
    instruction(merchant_uid: $merchant_uid, date: $date) {
      id
      merchant_uid
      date
      amount
      status
      scheduled_processing_date
      settlement_batch
      metadata
    }
  }
` as GeneratedQuery<
  APITypes.InstructionQueryVariables,
  APITypes.InstructionQuery
>;
export const invoice = /* GraphQL */ `
  query Invoice($invoice_id: String!) {
    invoice(invoice_id: $invoice_id) {
      account_code
      created_date
      currency
      due_by
      fee_mode
      invoice_amount
      invoice_date
      invoice_description
      invoice_id
      invoice_name
      merchant_invoice_number
      merchant_uid
      metadata
      offline_transactions {
        amount
        instance_id
        invoice_id
        note
        transaction_date
        type
      }
      payor {
        address_line1
        address_line2
        city
        country
        created_row_at
        email
        full_name
        merchant_uid
        metadata
        payor_id
        phone
        postal_code
        region
        updated_row_at
      }
      reference
      settings {
        accepted_payment_methods {
          ach
          card
          cash
        }
        is_secure
        require_payor_address
        security_pin
      }
      status
      total_paid_amount
      updated_row_at
    }
  }
` as GeneratedQuery<APITypes.InvoiceQueryVariables, APITypes.InvoiceQuery>;
export const invoiceCheckoutPage = /* GraphQL */ `
  query InvoiceCheckoutPage($invoice_id: String!) {
    invoiceCheckoutPage(invoice_id: $invoice_id) {
      account_code
      api_key
      country_code
      currency
      fee_mode
      invoice_amount
      invoice_description
      invoice_id
      invoice_name
      merchant_name
      merchant_uid
      payor {
        address_line1
        address_line2
        city
        country
        created_row_at
        email
        full_name
        merchant_uid
        metadata
        payor_id
        phone
        postal_code
        region
        updated_row_at
      }
      reference
      settings {
        accepted_payment_methods {
          ach
          card
          cash
        }
        is_secure
        require_payor_address
        security_pin
      }
      status
      total_paid_amount
      wallet_checkout_details {
        paze {
          active
          paze_key
          key_scope
          merchantDetails {
            mcc
            url
            statementDescriptor
            merchantName
          }
        }
        apple {
          active
        }
        google {
          active
          merchantIdentifier
        }
      }
    }
  }
` as GeneratedQuery<
  APITypes.InvoiceCheckoutPageQueryVariables,
  APITypes.InvoiceCheckoutPageQuery
>;
export const invoices = /* GraphQL */ `
  query Invoices(
    $query: SqlQuery
    $limit: Int
    $offset: String
    $direction: MoveDirection
    $offset_id: String
  ) {
    invoices(
      query: $query
      limit: $limit
      offset: $offset
      direction: $direction
      offset_id: $offset_id
    ) {
      items {
        account_code
        created_date
        currency
        due_by
        fee_mode
        invoice_amount
        invoice_date
        invoice_description
        invoice_id
        invoice_name
        merchant_invoice_number
        merchant_uid
        metadata
        offline_transactions {
          amount
          instance_id
          invoice_id
          note
          transaction_date
          type
        }
        payor {
          address_line1
          address_line2
          city
          country
          created_row_at
          email
          full_name
          merchant_uid
          metadata
          payor_id
          phone
          postal_code
          region
          updated_row_at
        }
        reference
        settings {
          accepted_payment_methods {
            ach
            card
            cash
          }
          is_secure
          require_payor_address
          security_pin
        }
        status
        total_paid_amount
        updated_row_at
      }
      total_row_count
    }
  }
` as GeneratedQuery<APITypes.InvoicesQueryVariables, APITypes.InvoicesQuery>;
export const jwks = /* GraphQL */ `
  query Jwks {
    jwks {
      keys {
        alg
        crv
        kid
        kty
        use
        x
      }
    }
  }
` as GeneratedQuery<Record<string, never>, APITypes.JwksQuery>;
export const merchant = /* GraphQL */ `
  query Merchant($merchant_uid: String, $merchant_name: String) {
    merchant(merchant_uid: $merchant_uid, merchant_name: $merchant_name) {
      ach_active
      api_key
      card_active
      cash_active
      country_code
      fee_matrix {
        ach {
          merchant_fee {
            basis_points
            fixed
            max_fee
          }
          service_fee {
            basis_points
            fixed
            max_fee
            min_fee
          }
        }
        ach_return_fee
        ach_return_disputed_fee
        business_credit {
          merchant_fee {
            basis_points
            fixed
          }
          service_fee {
            basis_points
            fixed
            min_fee
          }
        }
        business_debit {
          merchant_fee {
            basis_points
            fixed
          }
          service_fee {
            basis_points
            fixed
            min_fee
          }
        }
        amex {
          merchant_fee {
            basis_points
            fixed
          }
        }
        card {
          merchant_fee {
            basis_points
            fixed
          }
          service_fee {
            basis_points
            fixed
            min_fee
          }
        }
        card_account_updater
        cash
        chargeback_fee
        credit_card {
          merchant_fee {
            basis_points
            fixed
          }
          service_fee {
            basis_points
            fixed
            min_fee
          }
        }
        debit_card {
          merchant_fee {
            basis_points
            fixed
          }
          service_fee {
            basis_points
            fixed
            min_fee
          }
        }
        discover {
          merchant_fee {
            basis_points
            fixed
          }
        }
        interchange_plus
        international_card_basis
        mastercard {
          merchant_fee {
            basis_points
            fixed
          }
        }
        merchant_uid
        prepaid_card {
          merchant_fee {
            basis_points
            fixed
          }
          service_fee {
            basis_points
            fixed
            min_fee
          }
        }
        service_fee_enabled
        visa {
          merchant_fee {
            basis_points
            fixed
          }
        }
      }
      fee_model {
        interchange_plus
        merchant_fee {
          ach_basis
          ach_fixed
          card_basis
          card_fixed
        }
        service_fee {
          ach_basis
          ach_fixed
          card_basis
          card_fixed
        }
        service_fee_min {
          ach_basis
          ach_fixed
          card_basis
          card_fixed
        }
      }
      is_system
      max_transaction_amount
      merchant_name
      merchant_uid
      metadata
      parent_merchant_uid
      settings {
        contact_email
        contact_phone
        facebook
        instagram
        linkedin
        tiktok
        twitter
        website
      }
      submitted_onboarding
    }
  }
` as GeneratedQuery<APITypes.MerchantQueryVariables, APITypes.MerchantQuery>;
export const merchantOnboarding = /* GraphQL */ `
  query MerchantOnboarding($merchant_uid: ID!) {
    merchantOnboarding(merchant_uid: $merchant_uid) {
      banks {
        account_number
        account_type
        account_uses
        bank_code
        bank_name
        institution_number
        name
        transit_number
      }
      business {
        additional_underwriting_data {
          annual_ach_volume
          average_ach_transfer_amount
          average_card_transfer_amount
          business_description
          card_volume_distribution {
            card_present_percentage
            ecommerce_percentage
          }
          credit_check_allowed
          credit_check_ip_address
          credit_check_timestamp
          credit_check_user_agent
          merchant_agreement_accepted
          merchant_agreement_ip_address
          merchant_agreement_timestamp
          merchant_agreement_user_agent
          statement_descriptor
          refund_policy
          volume_distribution_by_business_type {
            business_to_business_volume_percentage
            business_to_consumer_volume_percentage
            other_volume_percentage
          }
        }
        underwriting_data {
          annual_card_volume
          business_address {
            city
            country
            line1
            line2
            postal_code
            region
          }
          has_accepted_credit_cards_previously
          business_name
          business_type
          delivery_0_days_percent
          delivery_1_to_7_days_percent
          delivery_8_to_14_days_percent
          delivery_15_to_30_days_percent
          delivery_over_30_days_percent
          doing_business_as
          incorporation_date
          incorporation_state
          max_transaction_amount
          mcc
          phone
          prod_serv_sold
          ownership_type
          tax_id
          url
        }
      }
      business_owners {
        address {
          city
          country
          line1
          line2
          postal_code
          region
        }
        dob
        email
        first_name
        last_name
        middle_name
        nationality
        owner_position
        percentage_ownership
        phone
        primary_owner
        tax_id
        title
        uid
      }
      country_code_of_operation
      is_locked
      merchant_uid
      needs_docs
      ticket_id
      user_email
      user_full_name
    }
  }
` as GeneratedQuery<
  APITypes.MerchantOnboardingQueryVariables,
  APITypes.MerchantOnboardingQuery
>;
export const merchants = /* GraphQL */ `
  query Merchants(
    $query: SqlQuery
    $limit: Int
    $offset: String
    $direction: MoveDirection
    $offset_id: String
  ) {
    merchants(
      query: $query
      limit: $limit
      offset: $offset
      direction: $direction
      offset_id: $offset_id
    ) {
      items {
        ach_active
        card_active
        cash_active
        country_code
        is_system
        merchant_name
        merchant_uid
        metadata
        parent_merchant_uid
        submitted_onboarding
        updated_row_at
      }
      total_row_count
    }
  }
` as GeneratedQuery<APITypes.MerchantsQueryVariables, APITypes.MerchantsQuery>;
export const missedRecurringPaymentData = /* GraphQL */ `
  query MissedRecurringPaymentData($recurring_id: String!) {
    missedRecurringPaymentData(recurring_id: $recurring_id) {
      fee
      number_of_payments_missed
      total_amount_owed
    }
  }
` as GeneratedQuery<
  APITypes.MissedRecurringPaymentDataQueryVariables,
  APITypes.MissedRecurringPaymentDataQuery
>;
export const nativeApps = /* GraphQL */ `
  query NativeApps {
    nativeApps {
      app_id
      apple_pay_expiration_date
      description
      device_check_key
      device_check_kid
      merchant_uid
      platform
    }
  }
` as GeneratedQuery<Record<string, never>, APITypes.NativeAppsQuery>;
export const paymentLinkCheckoutPage = /* GraphQL */ `
  query PaymentLinkCheckoutPage($link_id: String!) {
    paymentLinkCheckoutPage(link_id: $link_id) {
      accepted_payment_methods
      account_code
      amount
      amount_is_variable
      api_key
      call_to_action
      country_code
      currency
      custom_success_message
      fee_mode
      is_active
      max_amount
      merchant_name
      merchant_uid
      min_amount
      payment_description
      payment_name
      redirect_url
      require_phone
    }
  }
` as GeneratedQuery<
  APITypes.PaymentLinkCheckoutPageQueryVariables,
  APITypes.PaymentLinkCheckoutPageQuery
>;
export const paymentLinks = /* GraphQL */ `
  query PaymentLinks(
    $query: SqlQuery
    $limit: Int
    $offset: String
    $direction: MoveDirection
    $offset_id: String
  ) {
    paymentLinks(
      query: $query
      limit: $limit
      offset: $offset
      direction: $direction
      offset_id: $offset_id
    ) {
      items {
        accepted_payment_methods
        account_code
        amount
        amount_is_variable
        call_to_action
        created_date
        currency
        custom_success_message
        fee_mode
        is_active
        link_id
        link_name
        link_url
        max_amount
        merchant_uid
        min_amount
        payment_name
        payment_description
        redirect_url
        require_phone
      }
      total_row_count
    }
  }
` as GeneratedQuery<
  APITypes.PaymentLinksQueryVariables,
  APITypes.PaymentLinksQuery
>;
export const paymentMethodToken = /* GraphQL */ `
  query PaymentMethodToken($payment_method_id: String!) {
    paymentMethodToken(payment_method_id: $payment_method_id) {
      address_line1
      address_line2
      bank_account_type
      bank_code
      barcode_id
      card_brand
      card_type
      city
      country
      created_row_at
      cvv_status
      exp_date
      full_name
      is_active
      issuing_country_code
      last_four
      merchant_uid
      metadata
      payment_method_id
      payment_type
      payor {
        address_line1
        address_line2
        city
        country
        created_row_at
        email
        full_name
        merchant_uid
        metadata
        payor_id
        phone
        postal_code
        region
        updated_row_at
      }
      postal_code
      region
      updated_row_at
      wallet_type
    }
  }
` as GeneratedQuery<
  APITypes.PaymentMethodTokenQueryVariables,
  APITypes.PaymentMethodTokenQuery
>;
export const paymentMethodTokens = /* GraphQL */ `
  query PaymentMethodTokens(
    $query: SqlQuery
    $limit: Int
    $offset: String
    $direction: MoveDirection
    $offset_id: String
  ) {
    paymentMethodTokens(
      query: $query
      limit: $limit
      offset: $offset
      direction: $direction
      offset_id: $offset_id
    ) {
      items {
        address_line1
        address_line2
        bank_account_type
        bank_code
        barcode_id
        card_brand
        card_type
        city
        country
        created_row_at
        cvv_status
        exp_date
        full_name
        is_active
        issuing_country_code
        last_four
        merchant_uid
        metadata
        payment_method_id
        payment_type
        payor {
          address_line1
          address_line2
          city
          country
          created_row_at
          email
          full_name
          merchant_uid
          metadata
          payor_id
          phone
          postal_code
          region
          updated_row_at
        }
        postal_code
        region
        updated_row_at
        wallet_type
      }
      total_row_count
    }
  }
` as GeneratedQuery<
  APITypes.PaymentMethodTokensQueryVariables,
  APITypes.PaymentMethodTokensQuery
>;
export const payor = /* GraphQL */ `
  query Payor($payor_id: String!) {
    payor(payor_id: $payor_id) {
      address_line1
      address_line2
      city
      country
      created_row_at
      email
      full_name
      merchant_uid
      metadata
      payor_id
      phone
      postal_code
      region
      updated_row_at
    }
  }
` as GeneratedQuery<APITypes.PayorQueryVariables, APITypes.PayorQuery>;
export const payors = /* GraphQL */ `
  query Payors(
    $query: SqlQuery
    $limit: Int
    $offset: String
    $direction: MoveDirection
    $offset_id: String
  ) {
    payors(
      query: $query
      limit: $limit
      offset: $offset
      direction: $direction
      offset_id: $offset_id
    ) {
      items {
        address_line1
        address_line2
        city
        country
        created_row_at
        email
        full_name
        merchant_uid
        metadata
        payor_id
        phone
        postal_code
        region
        updated_row_at
      }
      total_row_count
    }
  }
` as GeneratedQuery<APITypes.PayorsQueryVariables, APITypes.PayorsQuery>;
export const pazeMerchantIdentity = /* GraphQL */ `
  query PazeMerchantIdentity($merchant_uid: ID!) {
    pazeMerchantIdentity(merchant_uid: $merchant_uid) {
      paze_id
      created_at
    }
  }
` as GeneratedQuery<
  APITypes.PazeMerchantIdentityQueryVariables,
  APITypes.PazeMerchantIdentityQuery
>;
export const recurringPayment = /* GraphQL */ `
  query RecurringPayment($recurring_id: String!) {
    recurringPayment(recurring_id: $recurring_id) {
      account_code
      amount_per_payment
      created_date
      currency
      fee_mode
      fee_per_payment
      is_active
      is_processing
      recurring_id
      merchant_uid
      metadata
      mute_all_emails
      next_payment_date
      payment_interval
      payment_method {
        address_line1
        address_line2
        bank_account_type
        bank_code
        barcode_id
        card_brand
        card_type
        city
        country
        created_row_at
        cvv_status
        exp_date
        full_name
        is_active
        issuing_country_code
        last_four
        merchant_uid
        metadata
        payment_method_id
        payment_type
        payor {
          address_line1
          address_line2
          city
          country
          created_row_at
          email
          full_name
          merchant_uid
          metadata
          payor_id
          phone
          postal_code
          region
          updated_row_at
        }
        postal_code
        region
        updated_row_at
        wallet_type
      }
      payor {
        address_line1
        address_line2
        city
        country
        created_row_at
        email
        full_name
        merchant_uid
        metadata
        payor_id
        phone
        postal_code
        region
        updated_row_at
      }
      prev_payment_date
      recurring_description
      recurring_name
      reference
      remaining_payments
      status
      total_amount_per_payment
      updated_row_at
    }
  }
` as GeneratedQuery<
  APITypes.RecurringPaymentQueryVariables,
  APITypes.RecurringPaymentQuery
>;
export const recurringPayments = /* GraphQL */ `
  query RecurringPayments(
    $query: SqlQuery
    $limit: Int
    $offset: String
    $direction: MoveDirection
    $offset_id: String
  ) {
    recurringPayments(
      query: $query
      limit: $limit
      offset: $offset
      direction: $direction
      offset_id: $offset_id
    ) {
      items {
        account_code
        amount_per_payment
        created_date
        currency
        fee_mode
        fee_per_payment
        is_active
        is_processing
        recurring_id
        merchant_uid
        metadata
        mute_all_emails
        next_payment_date
        payment_interval
        payment_method {
          address_line1
          address_line2
          bank_account_type
          bank_code
          barcode_id
          card_brand
          card_type
          city
          country
          created_row_at
          cvv_status
          exp_date
          full_name
          is_active
          issuing_country_code
          last_four
          merchant_uid
          metadata
          payment_method_id
          payment_type
          payor {
            address_line1
            address_line2
            city
            country
            created_row_at
            email
            full_name
            merchant_uid
            metadata
            payor_id
            phone
            postal_code
            region
            updated_row_at
          }
          postal_code
          region
          updated_row_at
          wallet_type
        }
        payor {
          address_line1
          address_line2
          city
          country
          created_row_at
          email
          full_name
          merchant_uid
          metadata
          payor_id
          phone
          postal_code
          region
          updated_row_at
        }
        prev_payment_date
        recurring_description
        recurring_name
        reference
        remaining_payments
        status
        total_amount_per_payment
        updated_row_at
      }
      total_row_count
    }
  }
` as GeneratedQuery<
  APITypes.RecurringPaymentsQueryVariables,
  APITypes.RecurringPaymentsQuery
>;
export const recurringUpdatePage = /* GraphQL */ `
  query RecurringUpdatePage($recurring_hash: String!) {
    recurringUpdatePage(recurring_hash: $recurring_hash) {
      amount
      api_key
      hash
      merchant_name
      payor_id
      payor_name
      recurring_description
      recurring_name
    }
  }
` as GeneratedQuery<
  APITypes.RecurringUpdatePageQueryVariables,
  APITypes.RecurringUpdatePageQuery
>;
export const serviceFee = /* GraphQL */ `
  query ServiceFee(
    $merchant_uid: String!
    $amount: Int!
    $bank_id: String
    $payment_type: String
    $is_ach: Boolean
    $payment_method_id: String
  ) {
    serviceFee(
      merchant_uid: $merchant_uid
      amount: $amount
      bank_id: $bank_id
      payment_type: $payment_type
      is_ach: $is_ach
      payment_method_id: $payment_method_id
    ) {
      fee_limit_reached
      fee
      total
      adjusted_total
    }
  }
` as GeneratedQuery<
  APITypes.ServiceFeeQueryVariables,
  APITypes.ServiceFeeQuery
>;
export const serviceFeeAmount = /* GraphQL */ `
  query ServiceFeeAmount($merchant_uid: String!, $amount: Int!) {
    serviceFeeAmount(merchant_uid: $merchant_uid, amount: $amount) {
      ach {
        fee_limit_reached
        fee
        total
        adjusted_total
      }
      card {
        fee_limit_reached
        fee
        total
        adjusted_total
      }
    }
  }
` as GeneratedQuery<
  APITypes.ServiceFeeAmountQueryVariables,
  APITypes.ServiceFeeAmountQuery
>;
export const settlements = /* GraphQL */ `
  query Settlements(
    $query: SqlQuery
    $limit: Int
    $offset: String
    $direction: MoveDirection
    $offset_id: String
  ) {
    settlements(
      query: $query
      limit: $limit
      offset: $offset
      direction: $direction
      offset_id: $offset_id
    ) {
      items {
        currency
        gross_amount
        gross_amount_64bit
        merchant_uid
        net_amount
        net_amount_64bit
        settlement_batch
        settlement_date
        status
        settlement_type
        transaction_debit_count
        transaction_dispute_count
        transaction_reversal_count
        transfer_date
        total_adjustments
        total_adjustments_64bit
        total_fees
        total_fees_64bit
        updated_row_at
      }
      total_row_count
    }
  }
` as GeneratedQuery<
  APITypes.SettlementsQueryVariables,
  APITypes.SettlementsQuery
>;
export const splits = /* GraphQL */ `
  query Splits(
    $query: SqlQuery
    $limit: Int
    $offset: String
    $direction: MoveDirection
    $offset_id: String
  ) {
    splits(
      query: $query
      limit: $limit
      offset: $offset
      direction: $direction
      offset_id: $offset_id
    ) {
      items {
        account_code
        amount
        currency
        created_at
        id
        merchant {
          ach_active
          card_active
          cash_active
          country_code
          is_system
          merchant_name
          merchant_uid
          metadata
          parent_merchant_uid
          submitted_onboarding
          updated_row_at
        }
        metadata
        payment_method {
          address_line1
          address_line2
          bank_account_type
          bank_code
          barcode_id
          card_brand
          card_type
          city
          country
          created_row_at
          cvv_status
          exp_date
          full_name
          is_active
          issuing_country_code
          last_four
          merchant_uid
          metadata
          payment_method_id
          payment_type
          payor {
            address_line1
            address_line2
            city
            country
            created_row_at
            email
            full_name
            merchant_uid
            metadata
            payor_id
            phone
            postal_code
            region
            updated_row_at
          }
          postal_code
          region
          updated_row_at
          wallet_type
        }
        reference
        settlement_batch
        transaction_id
        updated_row_at
      }
      total_row_count
    }
  }
` as GeneratedQuery<APITypes.SplitsQueryVariables, APITypes.SplitsQuery>;
export const supportConversation = /* GraphQL */ `
  query SupportConversation($merchant_uid: ID!, $ticket_id: ID!) {
    supportConversation(merchant_uid: $merchant_uid, ticket_id: $ticket_id) {
      support_notes {
        body
        support_docs {
          attachment_id
          doc_type
          name
        }
      }
      ticket_id
    }
  }
` as GeneratedQuery<
  APITypes.SupportConversationQueryVariables,
  APITypes.SupportConversationQuery
>;
export const transaction = /* GraphQL */ `
  query Transaction($transaction_id: String!) {
    transaction(transaction_id: $transaction_id) {
      account_code
      ach_return_details {
        return_code
        return_details
        transfer_type
      }
      additional_purchase_data {
        level3_data_line_item {
          item_code
          item_description
          item_qty_exp
          prod_code
          qty
          tax_amount
          tax_ind
          tax_rate
          tax_rt_exp
          tax_type_id
          unit_cost
          unit_of_msure
        }
        level3_data_summary {
          dest_postal_code
          discnt_amt
          duty_amt
          frght_amt
          order_num
          prod_desc
          purch_idfr
          tax_amt
          tax_ind
        }
      }
      authorization_id
      avs_status
      currency
      device_id
      dispute_status
      failure_reasons
      fee_mode
      fees
      flag_for_review
      gross_amount
      invoice {
        account_code
        created_date
        currency
        due_by
        fee_mode
        invoice_amount
        invoice_date
        invoice_description
        invoice_id
        invoice_name
        merchant_invoice_number
        merchant_uid
        metadata
        offline_transactions {
          amount
          instance_id
          invoice_id
          note
          transaction_date
          type
        }
        payor {
          address_line1
          address_line2
          city
          country
          created_row_at
          email
          full_name
          merchant_uid
          metadata
          payor_id
          phone
          postal_code
          region
          updated_row_at
        }
        reference
        settings {
          accepted_payment_methods {
            ach
            card
            cash
          }
          is_secure
          require_payor_address
          security_pin
        }
        status
        total_paid_amount
        updated_row_at
      }
      is_settled
      merchant {
        ach_active
        card_active
        cash_active
        country_code
        is_system
        merchant_name
        merchant_uid
        metadata
        parent_merchant_uid
        submitted_onboarding
        updated_row_at
      }
      merchant_uid
      metadata
      net_amount
      parent_id
      payment_method {
        address_line1
        address_line2
        bank_account_type
        bank_code
        barcode_id
        card_brand
        card_type
        city
        country
        created_row_at
        cvv_status
        exp_date
        full_name
        is_active
        issuing_country_code
        last_four
        merchant_uid
        metadata
        payment_method_id
        payment_type
        payor {
          address_line1
          address_line2
          city
          country
          created_row_at
          email
          full_name
          merchant_uid
          metadata
          payor_id
          phone
          postal_code
          region
          updated_row_at
        }
        postal_code
        region
        updated_row_at
        wallet_type
      }
      processor
      recurring {
        account_code
        amount_per_payment
        created_date
        currency
        fee_mode
        fee_per_payment
        is_active
        is_processing
        recurring_id
        merchant_uid
        metadata
        mute_all_emails
        next_payment_date
        payment_interval
        payment_method {
          address_line1
          address_line2
          bank_account_type
          bank_code
          barcode_id
          card_brand
          card_type
          city
          country
          created_row_at
          cvv_status
          exp_date
          full_name
          is_active
          issuing_country_code
          last_four
          merchant_uid
          metadata
          payment_method_id
          payment_type
          payor {
            address_line1
            address_line2
            city
            country
            created_row_at
            email
            full_name
            merchant_uid
            metadata
            payor_id
            phone
            postal_code
            region
            updated_row_at
          }
          postal_code
          region
          updated_row_at
          wallet_type
        }
        payor {
          address_line1
          address_line2
          city
          country
          created_row_at
          email
          full_name
          merchant_uid
          metadata
          payor_id
          phone
          postal_code
          region
          updated_row_at
        }
        prev_payment_date
        recurring_description
        recurring_name
        reference
        remaining_payments
        status
        total_amount_per_payment
        updated_row_at
      }
      reference
      refund_reason {
        reason_code
        reason_details
      }
      refund_voidable
      refunded_amount
      sale_id
      settlement_batch
      splits {
        account_code
        amount
        currency
        created_at
        id
        merchant {
          ach_active
          card_active
          cash_active
          country_code
          is_system
          merchant_name
          merchant_uid
          metadata
          parent_merchant_uid
          submitted_onboarding
          updated_row_at
        }
        metadata
        payment_method {
          address_line1
          address_line2
          bank_account_type
          bank_code
          barcode_id
          card_brand
          card_type
          city
          country
          created_row_at
          cvv_status
          exp_date
          full_name
          is_active
          issuing_country_code
          last_four
          merchant_uid
          metadata
          payment_method_id
          payment_type
          payor {
            address_line1
            address_line2
            city
            country
            created_row_at
            email
            full_name
            merchant_uid
            metadata
            payor_id
            phone
            postal_code
            region
            updated_row_at
          }
          postal_code
          region
          updated_row_at
          wallet_type
        }
        reference
        settlement_batch
        transaction_id
        updated_row_at
      }
      status
      timezone
      transaction_date
      transaction_id
      transaction_type
      updated_row_at
    }
  }
` as GeneratedQuery<
  APITypes.TransactionQueryVariables,
  APITypes.TransactionQuery
>;
export const transactions = /* GraphQL */ `
  query Transactions(
    $query: SqlQuery
    $limit: Int
    $offset: String
    $direction: MoveDirection
    $offset_id: String
  ) {
    transactions(
      query: $query
      limit: $limit
      offset: $offset
      direction: $direction
      offset_id: $offset_id
    ) {
      items {
        account_code
        ach_return_details {
          return_code
          return_details
          transfer_type
        }
        additional_purchase_data {
          level3_data_line_item {
            item_code
            item_description
            item_qty_exp
            prod_code
            qty
            tax_amount
            tax_ind
            tax_rate
            tax_rt_exp
            tax_type_id
            unit_cost
            unit_of_msure
          }
          level3_data_summary {
            dest_postal_code
            discnt_amt
            duty_amt
            frght_amt
            order_num
            prod_desc
            purch_idfr
            tax_amt
            tax_ind
          }
        }
        authorization_id
        avs_status
        currency
        device_id
        dispute_status
        failure_reasons
        fee_mode
        fees
        flag_for_review
        gross_amount
        invoice {
          account_code
          created_date
          currency
          due_by
          fee_mode
          invoice_amount
          invoice_date
          invoice_description
          invoice_id
          invoice_name
          merchant_invoice_number
          merchant_uid
          metadata
          offline_transactions {
            amount
            instance_id
            invoice_id
            note
            transaction_date
            type
          }
          payor {
            address_line1
            address_line2
            city
            country
            created_row_at
            email
            full_name
            merchant_uid
            metadata
            payor_id
            phone
            postal_code
            region
            updated_row_at
          }
          reference
          settings {
            accepted_payment_methods {
              ach
              card
              cash
            }
            is_secure
            require_payor_address
            security_pin
          }
          status
          total_paid_amount
          updated_row_at
        }
        is_settled
        merchant {
          ach_active
          card_active
          cash_active
          country_code
          is_system
          merchant_name
          merchant_uid
          metadata
          parent_merchant_uid
          submitted_onboarding
          updated_row_at
        }
        merchant_uid
        metadata
        net_amount
        parent_id
        payment_method {
          address_line1
          address_line2
          bank_account_type
          bank_code
          barcode_id
          card_brand
          card_type
          city
          country
          created_row_at
          cvv_status
          exp_date
          full_name
          is_active
          issuing_country_code
          last_four
          merchant_uid
          metadata
          payment_method_id
          payment_type
          payor {
            address_line1
            address_line2
            city
            country
            created_row_at
            email
            full_name
            merchant_uid
            metadata
            payor_id
            phone
            postal_code
            region
            updated_row_at
          }
          postal_code
          region
          updated_row_at
          wallet_type
        }
        processor
        recurring {
          account_code
          amount_per_payment
          created_date
          currency
          fee_mode
          fee_per_payment
          is_active
          is_processing
          recurring_id
          merchant_uid
          metadata
          mute_all_emails
          next_payment_date
          payment_interval
          payment_method {
            address_line1
            address_line2
            bank_account_type
            bank_code
            barcode_id
            card_brand
            card_type
            city
            country
            created_row_at
            cvv_status
            exp_date
            full_name
            is_active
            issuing_country_code
            last_four
            merchant_uid
            metadata
            payment_method_id
            payment_type
            payor {
              address_line1
              address_line2
              city
              country
              created_row_at
              email
              full_name
              merchant_uid
              metadata
              payor_id
              phone
              postal_code
              region
              updated_row_at
            }
            postal_code
            region
            updated_row_at
            wallet_type
          }
          payor {
            address_line1
            address_line2
            city
            country
            created_row_at
            email
            full_name
            merchant_uid
            metadata
            payor_id
            phone
            postal_code
            region
            updated_row_at
          }
          prev_payment_date
          recurring_description
          recurring_name
          reference
          remaining_payments
          status
          total_amount_per_payment
          updated_row_at
        }
        reference
        refund_reason {
          reason_code
          reason_details
        }
        refund_voidable
        refunded_amount
        sale_id
        settlement_batch
        splits {
          account_code
          amount
          currency
          created_at
          id
          merchant {
            ach_active
            card_active
            cash_active
            country_code
            is_system
            merchant_name
            merchant_uid
            metadata
            parent_merchant_uid
            submitted_onboarding
            updated_row_at
          }
          metadata
          payment_method {
            address_line1
            address_line2
            bank_account_type
            bank_code
            barcode_id
            card_brand
            card_type
            city
            country
            created_row_at
            cvv_status
            exp_date
            full_name
            is_active
            issuing_country_code
            last_four
            merchant_uid
            metadata
            payment_method_id
            payment_type
            payor {
              address_line1
              address_line2
              city
              country
              created_row_at
              email
              full_name
              merchant_uid
              metadata
              payor_id
              phone
              postal_code
              region
              updated_row_at
            }
            postal_code
            region
            updated_row_at
            wallet_type
          }
          reference
          settlement_batch
          transaction_id
          updated_row_at
        }
        status
        timezone
        transaction_date
        transaction_id
        transaction_type
        updated_row_at
      }
      total_row_count
    }
  }
` as GeneratedQuery<
  APITypes.TransactionsQueryVariables,
  APITypes.TransactionsQuery
>;
export const users = /* GraphQL */ `
  query Users($user_pool: UserPool!, $merchant_uid: String) {
    users(user_pool: $user_pool, merchant_uid: $merchant_uid) {
      email
      full_name
      phone
      user_status
      username
    }
  }
` as GeneratedQuery<APITypes.UsersQueryVariables, APITypes.UsersQuery>;
export const usersV2 = /* GraphQL */ `
  query UsersV2($user_pool: UserPool!, $merchant_uid: String) {
    usersV2(user_pool: $user_pool, merchant_uid: $merchant_uid) {
      user_id
      email
      full_name
      first_name
      last_name
      phone
      user_status
      roles
      user_pool_id
      merchant_uid
      permissions
    }
  }
` as GeneratedQuery<APITypes.UsersV2QueryVariables, APITypes.UsersV2Query>;
export const validatePaymentMethodOwnership = /* GraphQL */ `
  query ValidatePaymentMethodOwnership(
    $payment_method_id: String!
    $number: String!
  ) {
    validatePaymentMethodOwnership(
      payment_method_id: $payment_method_id
      number: $number
    )
  }
` as GeneratedQuery<
  APITypes.ValidatePaymentMethodOwnershipQueryVariables,
  APITypes.ValidatePaymentMethodOwnershipQuery
>;
export const walletRegistrationApple = /* GraphQL */ `
  query WalletRegistrationApple {
    walletRegistrationApple {
      domain_name
      merchant_identifier
    }
  }
` as GeneratedQuery<
  Record<string, never>,
  APITypes.WalletRegistrationAppleQuery
>;
export const webhookEvents = /* GraphQL */ `
  query WebhookEvents(
    $id: ID
    $event_id: ID
    $endpoint: String
    $result: WebhookNotificationResult
    $last_evaluated_key: String
    $limit: Int
  ) {
    webhookEvents(
      id: $id
      event_id: $event_id
      endpoint: $endpoint
      result: $result
      last_evaluated_key: $last_evaluated_key
      limit: $limit
    ) {
      events {
        endpoint
        error
        event
        finished_at
        id
        event_id
        request
        response
        result
        retry_count
        started_at
        status_code
      }
      last_evaluated_key
    }
  }
` as GeneratedQuery<
  APITypes.WebhookEventsQueryVariables,
  APITypes.WebhookEventsQuery
>;
export const webhooks = /* GraphQL */ `
  query Webhooks($endpoint: String) {
    webhooks(endpoint: $endpoint) {
      endpoint
      is_active
      name
    }
  }
` as GeneratedQuery<APITypes.WebhooksQueryVariables, APITypes.WebhooksQuery>;
